export class LibraryItem {
  id: string;
  name: string;
  author: string;
  isbn: string;
  description: string;
  imageLink: string;
  mainPhoto: string;
  availability: string
}

export class LibrarySubscription {
  cancelAt: number;
  canceledAt: number;
  currentPeriodEnd: number;
  email: string;
  status: string;
}

export class LibraryCategory {
  id: string;
  categoryName: string;
}
